import eventData from "../data/eventData";
import { refreshPage } from "../index";

export function eventsFilter() {
  if (document.querySelector(".m-news-events")) {
    const locationFilter = document.querySelector(".location-filter");
    const dateFilter = document.querySelector(".date-filter");
    const eventFilterResults = document.querySelector(
      ".filter-results--events",
    );
    const buttonFilters = document.querySelectorAll(".button-filter");
    const filterHeading = document.querySelector(".filter-heading");

    // Convert date string to Date object
    function convertDateStringToDate(dateString) {
      const parts = dateString.split("/");
      const formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
      return new Date(formattedDate);
    }

    // Dynamically generate checkboxes for locations
    function generateLocationCheckboxes(data) {
      const uniqueValues = [
        ...new Set(data.map((item) => item["event_location"])),
      ];

      // Get the default location from data-default attribute (if needed in the future)
      const defaultLocation = locationFilter.dataset.default;

      locationFilter.innerHTML = `
      ${uniqueValues
        .map(
          (value) => `
            <label>
              <input type="checkbox" value="${value}" ${
                value === defaultLocation ? "checked" : ""
              } /> 
              <span class="checkbox-text">${value}</span>
              <span class="custom-checkbox"></span>
            </label>
          `,
        )
        .join("")}
    `;
    }

    // Dynamically generate checkboxes for dates
    function generateDateCheckboxes(data) {
      const uniqueDates = [...new Set(data.map((item) => item["event_date"]))];

      dateFilter.innerHTML = `
      ${uniqueDates
        .map((value) => {
          const date = convertDateStringToDate(value);
          const month = new Intl.DateTimeFormat("en-GB", {
            month: "long",
          }).format(date);
          return `
            <label>
              <input type="checkbox" value="${value}" />
              <span class="checkbox-text">${month}</span>
              <span class="custom-checkbox"></span>
            </label>
          `;
        })
        .join("")}
    `;
    }

    // Update location count
    function updateLocationCount() {
      const selectedLocations = Array.from(
        locationFilter.querySelectorAll("input:checked"),
      );
      const countText =
        selectedLocations.length > 0
          ? "Location (" + selectedLocations.length + ")"
          : "Location";
      document.getElementById("location-heading").textContent = countText;
    }

    // Update date count
    function updateDateCount() {
      const selectedDates = Array.from(
        dateFilter.querySelectorAll("input:checked"),
      );
      const countText =
        selectedDates.length > 0
          ? "Month (" + selectedDates.length + ")"
          : "Month";
      document.getElementById("date-heading").textContent = countText;
    }

    // Update overall filter count
    function updateFilterCount() {
      const selectedLocations = Array.from(
        locationFilter.querySelectorAll("input:checked"),
      );
      const selectedDates = Array.from(
        dateFilter.querySelectorAll("input:checked"),
      );

      const locationCount = selectedLocations.length > 0 ? 1 : 0;
      const dateCount = selectedDates.length > 0 ? 1 : 0;

      const totalSelectedFilters = locationCount + dateCount;

      buttonFilters.forEach((buttonFilter) => {
        if (totalSelectedFilters > 0) {
          buttonFilter.textContent = `Filter (${totalSelectedFilters})`;
        } else {
          buttonFilter.textContent = "Filter";
        }
      });

      // if (totalSelectedFilters > 0) {
      //   filterHeading.textContent = `Filter (${totalSelectedFilters}):`;
      // } else {
      //   filterHeading.textContent = "Filter";
      // }

      filterHeading.textContent = "Filter:";
    }

    // Filter and display results
    function filterAndDisplayResults() {
      const selectedLocations = Array.from(
        locationFilter.querySelectorAll("input:checked"),
      ).map((checkbox) => checkbox.value);

      const selectedDates = Array.from(
        dateFilter.querySelectorAll("input:checked"),
      ).map((checkbox) => checkbox.value);

      // Clear previous results
      eventFilterResults.innerHTML = "";

      // Filter and display results
      eventData.event_feed.forEach((event) => {
        const locationMatch =
          selectedLocations.length === 0 ||
          selectedLocations.includes(event.event_location);

        const dateMatch =
          selectedDates.length === 0 ||
          selectedDates.includes(event.event_date);

        if (locationMatch && dateMatch) {
          // Create an li element for each matching event
          const eventItem = document.createElement("li");
          eventItem.innerHTML = `
          <a href="${event.permalink}" target="_blank">
            <span class="image">
              <div class="image-container">
                ${event.image}
              </div>
            </span>
            <span class="details">
              <ul>
                <li>${event.event_location}</li>
                <li>${event.event_date}</li>
                <li>${event.price}</li>
              </ul>
            </span>
            <h3>${event.title}</h3>
            <span class="button-circled">Learn More</span>
          </a>`;

          // Append item to the results container
          eventFilterResults.appendChild(eventItem);
        }
      });

      // Update functions
      updateLocationCount();
      updateDateCount();
      updateFilterCount();

      refreshPage();
    }

    // Init checkboxes for locations and dates
    generateLocationCheckboxes(eventData.event_feed);
    generateDateCheckboxes(eventData.event_feed);

    // Filter and display results on page load
    filterAndDisplayResults();

    // Checkbox changes
    locationFilter.addEventListener("change", filterAndDisplayResults);
    dateFilter.addEventListener("change", filterAndDisplayResults);

    // Reset filter
    const newsButton = document.querySelector(".news-button");

    if (newsButton) {
      newsButton.addEventListener("click", () => {
        setTimeout(function () {
          resetFilter();
        }, 300);
      });
    }

    function resetFilter() {
      document
        .querySelectorAll(".events-filter-sidebar input:checked")
        .forEach((input) => {
          input.checked = false;
        });

      document
        .querySelectorAll(".events-filter-sidebar .c-accordion-item")
        .forEach((item) => {
          item.classList.add("closed");
        });

      filterAndDisplayResults();
    }
  }
}
